import React, { FC, useState } from 'react';
import { explanationIds } from '../../../common/authentication/models/user';
import NavActions, { navActionEnum } from './NavActions/NavActions';
import styles from './NavigationComponent.module.css';
import NavItems, { NavItem } from './NavItems/NavItems';

export interface NavLevel {
    title: string,
    active: boolean,
    items: NavItem[],
    actionsAllowed: navActionEnum[],
}

interface NavigationComponentProps {
    levels: NavLevel[]
    setLevels: (levels: NavLevel[]) => void
    toggleLevelItem: (level: NavLevel, item: NavItem, action: navActionEnum) => void,
}

const NavigationComponent: FC<NavigationComponentProps> = ({ levels, setLevels, toggleLevelItem }) => {

    const getBreadCrumb = () => {
        const levelsWithInBetween: { level: NavLevel, separator: boolean }[] = [];
        for (let i = 0; i < levels.length; i++) {
            const l = levels[i];
            if (l.items && l.items.length) {
                levelsWithInBetween.push({
                    level: l,
                    separator: false
                })
                if (i < levels.filter(l => (l.items.length > 0)).length - 1) {
                    levelsWithInBetween.push({
                        level: undefined,
                        separator: true
                    })
                }
            }
        }

        return <>
            {
                levelsWithInBetween.map((lb, index) => {

                    if (!lb.separator && lb.level.items && lb.level.items.length) {
                        return <span key={lb.level.title + index}>
                            <button onClick={() => toggleLevel(lb.level)} className={`${styles.levelBtn} ${lb.level.active ? styles.active : ''}`}>
                                {lb.level.title}
                            </button>
                        </span>
                    } else if (lb.separator) {
                        return <span className={styles.separator} key={'separator-' + index}>
                            {">"}
                        </span>
                    }
                })
            }
        </>

    }

    const toggleLevel = (level: NavLevel) => {
        setLevels(levels.map(l => {
            if (l.title === level.title) {
                l.active = true;
            } else {
                l.active = false;
            }
            return { ...l };
        }));
    }

    const toggleItem = (level: NavLevel, item: NavItem) => {
        toggleLevelItem(level, item, navActionEnum.toggle);
    }

    return <div data-explanation-id={explanationIds.buildingNavigation} className={styles.NavigationComponent} data-testid="NavigationComponent" >
        <div className={`${styles.breadcrumb}`}>
            {
                getBreadCrumb()
            }
        </div>
        {
            levels.map((level, index) => {
                if (level.active) {
                    return <span key={'nav-' + level.title + index}>
                        {level.items && level.items.length && <NavItems items={level.items} onItemToggle={(item: NavItem) => {
                            toggleItem(level, item);
                        }} />}
                        <NavActions title={level.title}
                            allowedActions={level.actionsAllowed}
                            onAdd={() => {
                                toggleLevelItem(level, undefined, navActionEnum.add);
                            }}
                            onEdit={() => {
                                toggleLevelItem(level, level.items?.find(i => i.active), navActionEnum.edit);
                            }}
                            onArchive={() => {
                                toggleLevelItem(level, level.items?.find(i => i.active), navActionEnum.archive);
                            }}
                            onDuplicate={() => {
                                toggleLevelItem(level, level.items?.find(i => i.active), navActionEnum.duplicate);
                            }}
                        />
                    </span>
                }
            })
        }
    </div >
};

export default NavigationComponent;
